import { FormattedMessage } from "react-intl";
import localizations from "client/i18n/localization";

const i18nRender = (param, locale) => {
  const hasObj = param instanceof Object;
  const isLocaleEnglish = locale === "en-US";

  let values;
  if (hasObj) {
    const obj = param.values;

    const newObj = {};
    const localeKey = isLocaleEnglish ? "en" : "ur";

    Object.keys(obj).forEach((key) => {
      newObj[key] = obj[key][localeKey];
    });
    values = newObj;
  } else {
    values = null;
  }

  return (
    <FormattedMessage
      id={hasObj ? param.string : param}
      defaultMessage="this.text.is.not.localized"
      values={values}
    />
  );
};

const i18n = (string, obj = null) => {
  if (obj) {
    return { string, values: obj };
  }

  return string;
};

const dirI18n = (string, localeString) => {
  return localizations[localeString][string];
};

const i18nFunctions = { i18n, i18nRender, dirI18n };

export default i18nFunctions;
